const CENTRAL_TIME_ZONE = "America/Chicago";

const centralDateKeyFormatter = new Intl.DateTimeFormat("en-CA", {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  timeZone: CENTRAL_TIME_ZONE,
});

export const toDateValue = (value) => {
  if (!value) {
    return null;
  }

  if (typeof value.toDate === "function") {
    return value.toDate();
  }

  if (value instanceof Date) {
    return value;
  }

  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

export const formatLabDate = (dateValue) => {
  const date = toDateValue(dateValue);
  if (!date) {
    return "Date TBD";
  }

  return new Intl.DateTimeFormat("en-US", {
    weekday: "long",
    month: "long",
    day: "numeric",
    year: "numeric",
    timeZone: CENTRAL_TIME_ZONE,
  }).format(date);
};

export const formatLabTimeRange = (dateValue, durationMinutes = 60) => {
  const startDate = toDateValue(dateValue);
  if (!startDate) {
    return "Time TBD";
  }

  const endDate = new Date(startDate.getTime() + durationMinutes * 60 * 1000);

  const formatter = new Intl.DateTimeFormat("en-US", {
    hour: "numeric",
    minute: "2-digit",
    timeZone: CENTRAL_TIME_ZONE,
  });

  return `${formatter.format(startDate)}-${formatter.format(endDate)} CT`;
};

export const getUserTimeZoneName = () => {
  try {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return timeZone || "your local timezone";
  } catch (error) {
    return "your local timezone";
  }
};

export const formatLabDateInUserTimeZone = (dateValue) => {
  const date = toDateValue(dateValue);
  if (!date) {
    return "Date TBD";
  }

  return new Intl.DateTimeFormat("en-US", {
    weekday: "long",
    month: "long",
    day: "numeric",
    year: "numeric",
  }).format(date);
};

export const formatLabDateShortInUserTimeZone = (dateValue) => {
  const date = toDateValue(dateValue);
  if (!date) {
    return "Date TBD";
  }

  return new Intl.DateTimeFormat("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
  }).format(date);
};

export const formatLabTimeRangeInUserTimeZone = (dateValue, durationMinutes = 60) => {
  const startDate = toDateValue(dateValue);
  if (!startDate) {
    return "Time TBD";
  }

  const endDate = new Date(startDate.getTime() + durationMinutes * 60 * 1000);
  const timeFormatter = new Intl.DateTimeFormat("en-US", {
    hour: "numeric",
    minute: "2-digit",
  });
  const zonePart = new Intl.DateTimeFormat("en-US", {
    timeZoneName: "short",
  })
    .formatToParts(startDate)
    .find((part) => part.type === "timeZoneName")?.value;

  return `${timeFormatter.format(startDate)}-${timeFormatter.format(endDate)} ${
    zonePart || ""
  }`.trim();
};

export const isFutureLab = (dateValue) => {
  const date = toDateValue(dateValue);
  if (!date) {
    return false;
  }

  return date.getTime() >= Date.now();
};

export const isTodayInCentralTime = (dateValue) => {
  const date = toDateValue(dateValue);
  if (!date) {
    return false;
  }

  const labDateKey = centralDateKeyFormatter.format(date);
  const nowDateKey = centralDateKeyFormatter.format(new Date());
  return labDateKey === nowDateKey;
};
